function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { InlineInput } from 'seagull/components/TableList/InlineControl/InlineInput';
import { useFeatureFlags } from "../../../hooks/useFeatureFlags";
import { AccountingMappingIndication } from "../../../integrations/Accounting/AccountingMappingIndication/AccountingMappingIndication";
import { selectors } from "../../../store/state-selectors";
import { useStore } from "../../../store/store-context";
import { Accounting } from "../../../types/api.model";
import styles from "./ServiceRowName.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ServiceRowName(_ref) {
  let {
    service,
    serviceNameValidation,
    qboServiceDisplay,
    xeroServiceDisplay,
    onInlineEdit,
    onInputFocus,
    onInputBlur
  } = _ref;
  const showQboIntegration = useStore(selectors.integration.showQboIntegration);
  const showXeroIntegration = useStore(selectors.integration.showXeroIntegration);
  const {
    control,
    setValue
  } = useForm({
    mode: 'all',
    defaultValues: {
      name: service.name
    }
  });
  const {
    XERO_INTEGRATION
  } = useFeatureFlags();
  useEffect(() => {
    setValue('name', service.name);
  }, [service.name, setValue]);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.serviceName,
    children: [/*#__PURE__*/_jsx(Controller, {
      control: control,
      name: "name",
      rules: serviceNameValidation,
      render: _ref2 => {
        var _fieldState$error;
        let {
          field,
          fieldState
        } = _ref2;
        return /*#__PURE__*/_jsx(InlineInput, _objectSpread(_objectSpread({}, field), {}, {
          onFocus: onInputFocus,
          onBlur: onInputBlur,
          onSave: name => onInlineEdit({
            name
          }),
          error: !!fieldState.error,
          errorText: (_fieldState$error = fieldState.error) === null || _fieldState$error === void 0 ? void 0 : _fieldState$error.message,
          errorTextInTooltip: true,
          testId: "service-library-row-name"
        }));
      }
    }), showQboIntegration && /*#__PURE__*/_jsx(AccountingMappingIndication, {
      display: qboServiceDisplay,
      purpose: "service",
      accounting: Accounting.QBO
    }), showXeroIntegration && XERO_INTEGRATION && /*#__PURE__*/_jsx(AccountingMappingIndication, {
      display: xeroServiceDisplay,
      purpose: "service",
      accounting: Accounting.Xero
    })]
  });
}